import ko from "knockout";

ko.bindingHandlers.password = {

    init: function(element, valueAccessor, allBindings) {

        var icon = $('<span class="fa fa-eye show-password-icon" />'),
            $element = $(element);
        icon.insertAfter($element);

        $element.attr("type", "password");

        icon.off("click").on("click",function(){

            var currentType = $element.attr("type"),
                nextType = currentType=="text"? "password" : "text";

            icon.removeClass("fa-eye fa-eye-slash");
            icon.addClass(nextType=="text"? "fa-eye-slash" : 'fa-eye');
            $element.attr("type", nextType);
        });


        ko.bindingHandlers.textInput.init(element, valueAccessor, allBindings);
    },

    update: function(element, valueAccessor, allBindings) {
        //ko.bindingHandlers.textInput.update(element, valueAccessor, allBindings);
    }


};


//////////////////
// WEBPACK FOOTER
// ./cdn/bindings/password.js
// module id = 2
// module chunks = 0